import type { IconProps } from './types';

export const RightAlignIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M20.5 17.4629L20.5771 17.4668C20.9551 17.5054 21.2499 17.8248 21.25 18.2129C21.25 18.601 20.9551 18.9203 20.5771 18.9589L20.5 18.9629H6C5.58579 18.9629 5.25 18.6271 5.25 18.2129C5.25012 17.7987 5.58586 17.4629 6 17.4629H20.5ZM20.5 11.25L20.5771 11.2539C20.9551 11.2925 21.25 11.6118 21.25 12C21.25 12.3881 20.9551 12.7074 20.5771 12.7461L20.5 12.75H13C12.5858 12.75 12.25 12.4142 12.25 12C12.25 11.5858 12.5858 11.25 13 11.25H20.5ZM20.5 5.04C20.9142 5.04 21.25 5.37579 21.25 5.79C21.25 6.20421 20.9142 6.54 20.5 6.54H3.5C3.08579 6.54 2.75 6.20421 2.75 5.79C2.75 5.37579 3.08579 5.04 3.5 5.04H20.5Z"
        fill={color}
      />
    </svg>
  );
};
